import { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import IndexHero from "@/components/home/IndexHero";
import PopularPrompts from "@/components/home/PopularPrompts";
import FeatureSection from "@/components/home/FeatureSection";
import CtaSection from "@/components/home/CtaSection";
import ContributorSection from "@/components/home/ContributorSection";
import { usePopularPrompts } from "@/hooks/usePopularPrompts";
import { useCategories } from "@/hooks/useCategories";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const features = [
  {
    title: "Find the perfect prompt",
    description: "Search and filter through a curated collection of prompts for various use cases."
  },
  {
    title: "Save time with templates",
    description: "Use pre-made templates to generate high-quality outputs without starting from scratch."
  },
  {
    title: "Share your expertise",
    description: "Create and share your own prompts to help others and showcase your knowledge."
  },
  {
    title: "Earn points and badges",
    description: "Get recognized for your contributions with our gamified system and climb the leaderboard."
  }
];

const Index = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { categories, isLoading: isLoadingCategories } = useCategories();
  const { 
    prompts: featuredPrompts, 
    isLoading: isLoadingPrompts, 
    error: promptsError,
    refetch: refetchPrompts
  } = usePopularPrompts(8);

  const handleSearch = (query: string) => {
    navigate(`/explore?q=${encodeURIComponent(query)}`);
  };
  
  useEffect(() => {
    console.log("Featured prompts changed:", { 
      count: featuredPrompts?.length || 0, 
      isLoading: isLoadingPrompts,
      hasError: !!promptsError
    });
    
    if (promptsError) {
      console.error("Error loading featured prompts:", promptsError);
    }
  }, [featuredPrompts, isLoadingPrompts, promptsError]);

  console.log("Index page rendering with prompts:", 
    featuredPrompts ? `${featuredPrompts.length} prompts` : 'no prompts', 
    "loading:", isLoadingPrompts
  );

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <IndexHero onSearch={handleSearch} />
      <PopularPrompts 
        prompts={featuredPrompts || []} 
        isLoading={isLoadingPrompts} 
        error={promptsError}
        refetch={refetchPrompts}
      />
      <ContributorSection />
      <FeatureSection features={features} />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Index;
